import React, { Component } from 'react';
import { BusyContainer, CustomMessage } from '../../../components';
import { connect } from 'react-redux';
import { ModelConfigurator } from './model';
import { configuratorActions, getLanguages, sessionStore } from '../../../services';
import { configuratorDispatcher, configuratorState, currentNodeState, identityState, combineStates, identityDispatcher, combineDispatchers, siteSettingsState, priceState, showFooterDispatcher, currentPageState, currentPageDispatcher,modelConfiguratorDispatcher,modelConfiguratorState} from '../../../store';
import { PropTypes } from 'prop-types';
import { TranslationService, getTranslationModelName, deflateModelVariables,getUserAssignments } from '../../../util';
import { translate } from '../../../services';

export class ModelConfiguratorPageComponent extends Component {
  state = {
    oldProduct: null,
  }
  componentDidMount() {
    this.resetConfiguration();
    this.props.resetQuantityList();
    this.getOldProduct();
  }  

  getOldProduct() {
    const { configurations } = this.props;
    const location = window.location.href;
    if(location.indexOf('reconfigure') > -1) {
      const nodeCID = location.split('/').pop();
      const oldProduct = configurations && configurations[nodeCID];
      if(oldProduct) {
        oldProduct.multiValueProducts = [];
        oldProduct.wildArticles = [];
        let cartconfiguration = oldProduct && oldProduct.configuration;
        const lang = getLanguages().first() || "EN";
        const multiValueProducts = cartconfiguration.model.children.map(c => ({...c.variables.find(v => v.properties.IsBomItem === true && v.properties.BomItemType === "MultiValue"), group: c.properties[lang]}));
        this.props.setNewAmountToQuantityList(this.props.modelConfigurator,oldProduct.code, oldProduct.amount);
        let bomItems = cartconfiguration?.bomComponents || oldProduct.importAccessories?.map(i => ({...i, component: i.accessoryCode, quantity: i.quantity})) || [];
        for(let bom of bomItems) {
          multiValueProducts.forEach(m => m && m.values?.find(v => {
            if(v.name === bom.component) oldProduct.multiValueProducts.push({...m, assignedValue : v, values : [], group: m.group})
          }));
          if(bom.component?.includes('WA_')) {
            oldProduct.wildArticles.push({
                assignedValue: {
                  name: bom.component,
                  title: bom.description
                },
                group: 'Wild Articles',
                netPrice: bom.netPrice,
                name: bom.component,
                code: bom.component,
                description: bom.description
            })
          }
          this.props.setNewAmountToQuantityList(this.props.modelConfigurator,bom.component, parseInt(bom.quantity));
        }

        this.setState({oldProduct: oldProduct});
        this.props.removeProductFromModelConfigurator(oldProduct); 
        this.props.loadProduct( {...oldProduct, name:this.props.product.name})
        .then(() => {
          this.setPreselectedValues(cartconfiguration);
          const bomItemMain = this.getBomItemMain(cartconfiguration);
          if(bomItemMain && cartconfiguration?.materialKey!=='BUSWAY') {
           this.assignValue(bomItemMain.fullyQualifiedName, bomItemMain.values?.find(v => v.name === oldProduct.name)?.name);
          }
        });
      }
      else {
        window.location.href = location.replace('reconfigure', 'configurator');
      }
    } else {
      this.resetConfiguration();
    }
  }

  getBomItemMain = (configuration) => {
    let mainField = null;
    configuration.model.children.forEach(c => {
      let bomVariable = c.variables?.find(v => v.properties.IsBomItem && v.properties.BomItemType === "Main");
      if(bomVariable) mainField = bomVariable;
    });

    return mainField;
  }

  setPreselectedValues( configuration ) {
    if ( !configuration ) {
      return null;
    }
    const assignmentsDict = configuration.assignments.reduce( ( accumulatorDict, currentAssignment ) => {
      accumulatorDict[currentAssignment.Key || currentAssignment.key] = currentAssignment.Value || currentAssignment.value;
      return accumulatorDict;
    }, {} );
    // adding preselections to existing assignments
    // this way complete configuration is understood to be done first time
    // not as a delta 
    var existingassignments = getUserAssignments( configuration ).filter( assignment => assignmentsDict[assignment.key] !== assignment.value );
    configuration.assignments.push( ...existingassignments );
    return this.fromTemplate( configuration, [] );
  }

  fromTemplate( template, assignments ) {
    const configuration = this.getConfiguration();
    return this.props.fromTemplate( configuration, template, assignments.sort( ( a, b ) => a.key > b.key ? 1 : -1 ), this.props.product.name );
  }

  getConfiguration() {
    const { configurations, product, currentNode } = this.props;
    const { modelOptimization, filters, masterFilter } = currentNode && currentNode.customProperties;
    const configuration = configurations[product.name] && configurations[product.name][0];
    const { oldProduct } = this.state;
    if ( !configuration ) {
      return null;
    }
    if(oldProduct) {
      configuration.isReconfigure = true;
    }

    if(modelOptimization){
      configuration.optimizedModel = modelOptimization;
    }

    if(filters){
      configuration.filters = filters;
    }

    if(masterFilter){
      configuration.masterFilter = masterFilter;
    }

    const translationService = TranslationService( getTranslationModelName( configuration ), 'model' )( getLanguages().first() );
    return { ...configuration, model: translationService.withGroups( configuration.model ) };
  }

  resetConfiguration = e => {
    this.props.loadProduct( this.props.product ).then( args => {
      let q = Promise.resolve();
      if ( this.props.prefilters && this.props.prefilters.preset ) {
        for ( let filter of this.props.prefilters.preset ) {
          q = q.then( () => this.assignValue( filter.name, filter.value ) );
        }
      }
      return q.then( () => args );
    } );
    this.props.resetQuantityList();
    e && e.preventDefault();
  }
  
  resetGroup = ( e, group ) => {
    const configuration = this.getConfiguration();
    this.props.resetGroup( configuration, configuration, group );
    e && e.preventDefault();
  }

getAllVariables( model ) {
  return deflateModelVariables( model );
}

getAllVariableValues(model){
  const variables = this.getAllVariables(model);
  var allVariables = [];
  variables.map(v=>{allVariables.push(v.name+':'+v.textValue)});
  return allVariables;
}

changeCustomerCode =(configuration) =>
  {
    const { currentNode, siteSettings, prices } = this.props;
    let customeCountryName = currentNode.customProperties.Country;
    const { model } = configuration;
    //PriceSelector is from hierarchy.json. Price will be loaded only if user selects this item
    const {PriceSelector} = currentNode && currentNode.customProperties;
    //customeCountryName is a list of country names from hierarchy.json
    //countries from this list used to construct the customercode to fetch price
    const variableCountry = this.getAllVariables( model ).filter( v => customeCountryName.includes(v.fullyQualifiedName) );
    const variable = this.getAllVariables( model ).firstOrDefault( v => v.fullyQualifiedName === PriceSelector );

    if(variable.assignedValue && variableCountry ){
      //customerCode counstructed using PriceSelector and customeCountryName values
      let countryCustomerCode = '';
      variableCountry.forEach(v => {
        if ( v.assignedValue != null && countryCustomerCode.indexOf(siteSettings.customerCodeMappings[v.assignedValue?.name]) < 0){
        countryCustomerCode += siteSettings.customerCodeMappings[v.assignedValue?.name] + '_' || '' ;
      }
      });
      const customerCode = countryCustomerCode + variable.assignedValue.name;
      let data = this.props.user;
      let produtCode = [];
      if(data.properties.CustomerCode != customerCode){
      data.properties.CustomerCode = customerCode;
      this.props.updateUser(data);
      configuration.model.children[0].variables.forEach((v) => {
        if(v.fullyQualifiedName == "Selector.varTypeOfService"){//read it from Hierarchy JSON
           produtCode.push(v.textValue);
        }
      });
       let pricesData = Object.keys(prices);
       pricesData.forEach(key=>{
         if(key == produtCode)
         {
           delete prices[key];
         }
       })
      
      }
    }
}
  assignValue = ( variable, value ) => {
    const configuration = this.getConfiguration();
    return this.props.assignValue( configuration, configuration, variable, value, this.props.product.name );
   }

  removeValue = ( variable, value ) => {
    const configuration = this.getConfiguration();
    this.props.removeValue( configuration, configuration, variable, value );
  }

  render() {
    if(this.props.currentPage.currentPage!=="modelConfiguratorPage"){
      this.props.setPage("modelConfiguratorPage")
   }
    const { currentNode } = this.props;
    const {PriceSelector} = currentNode && currentNode.customProperties;
    let configuration = this.getConfiguration();

    this.props.hideFooter();
    if(configuration){
      if(PriceSelector){
      //Budget/Service configurator changes
      this.changeCustomerCode(configuration);
      }
      configuration.modelOptimization = currentNode.customProperties.modelOptimization ? currentNode.customProperties.modelOptimization : false;
    }

    const modelBusyActions = Object.keys( configuratorActions ).map( key => configuratorActions[key] );
    const customMessage =currentNode.customProperties.customMessage ?translate( currentNode.customProperties.customMessage ):currentNode.customProperties.customeMessage && translate( currentNode.customProperties.customeMessage );
    const customMessageColor=currentNode?.customProperties?.customMessageColor;
const isVT = currentNode.customProperties.isVT; 

    let configurator = !configuration ? null :
      <ModelConfigurator 
        configuration={ configuration }
        resetConfigurator={ this.resetConfiguration }
        resetGroup={ this.resetGroup }
        assignValue={ this.assignValue }
        removeValue={ this.removeValue }
        oldProduct={ this.state.oldProduct }

      />;

    return <div className='model-configurator-page'>
      <BusyContainer actions={ modelBusyActions }> 
        <CustomMessage  message={ customMessage } color={customMessageColor}  node ={isVT}/>  
      </BusyContainer>
      { configurator }
    </div>;
  }
}

ModelConfiguratorPageComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  configurations: PropTypes.shape( {} ),
  loadProduct: PropTypes.func.isRequired,
  prefilters: PropTypes.shape( {
    values: PropTypes.array
  } ),
  product: PropTypes.shape( {} ),
  removeValue: PropTypes.func.isRequired,
  resetGroup: PropTypes.func.isRequired
};
export const ModelConfiguratorPage = connect( combineStates( configuratorState,modelConfiguratorState, identityState, currentNodeState, siteSettingsState, priceState, currentPageState ),combineDispatchers (configuratorDispatcher,currentPageDispatcher ,showFooterDispatcher, identityDispatcher,modelConfiguratorDispatcher ))( ModelConfiguratorPageComponent );